const chMessages = {
 "main.name": "Nom",
  "main.sentiment": "Sentiment",
  "main.urgency": "Urgence",
  "main.language": "Langue",
  "main.agent": "Agent",
  "main.property_name": "Nom de l'établissement",
  "main.booking_number": "Numéro de réservation",
  "main.check_out": "Départ",
  "main.check_in": "Arrivée",
  "main.adults": "Adultes",
  "main.corporate_code": "Code entreprise",
  "main.group_code": "Code groupe",
  "main.promo_code": "Code promotionnel",
  "main.ai_response": "Réponse IA",
  "main.template_response": "Réponse du modèle",
  "main.converttoticket": "Convertir en ticket",
  "main.switch_property": "Changer d'établissement",
  "main.Group_id": "ID du groupe",
  "main.integration_id": "ID d'intégration",
  "main.submit": "Envoyer",
  "main.cancel": "Annuler",
    "main.select_template": "Sélectionner un modèle",
  "main.rooms": "Chambres",
  "main.rates": "Tarifs",

  //footer
   "footer.knowledge": "Connaissances",
  "footer.home": "Accueil",
  "footer.help": "Aide",

  //ticket
  "ticket.thank_you": "Merci d'avoir envoyé le formulaire",
  "ticket.ticket": "Ticket",
  "ticket.details": "Veuillez remplir le formulaire en décrivant les détails du ticket.",
  "ticket.select_category": "Sélectionner une catégorie",
  "ticket.category": "Catégorie",
  "ticket.title": "Titre",
  "ticket.notes": "Notes",
  "ticket.status": "Statut",
  "ticket.assigned_to": "Attribué à",
  "ticket.submit_form": "Envoyer le formulaire",


  "main.total": "Total",
  "main.pastetooutlook": "Coller dans Outlook",
  "main.children": "Enfants",
  "main.promocode": "Code promo/entreprise/groupe",
  "main.exact_match_only": "Correspondance exacte uniquement",
  "main.search": "Rechercher",
  "main.no_rate_match": "Aucun tarif ne correspond à votre sélection. Veuillez modifier votre recherche et réessayer.",
  "main.translate_to": "Traduire vers",
  "main.regenerate": "Régénérer",
  "main.copy_text": "Copier le texte",
  "main.additional_instructions": "Instructions supplémentaires",

  "faq.helpcenter": "Centre d'aide",
  "faq.reply.email.sabre.question": "Comment répondre à un e-mail avec l'automatisation des e-mails Aven Hospitality Concierge ?",
  "faq.reply.email.sabre.answer": "Ouvrez l'e-mail et lancez le module complémentaire Aven Hospitality. Vous pouvez choisir entre trois options : utiliser un modèle prédéfini, générer une réponse IA ou convertir l'e-mail en ticket. Sélectionnez l'option adaptée à la demande, vérifiez la réponse, effectuez les modifications nécessaires et envoyez directement depuis Outlook.",

  "faq.rates.availability.question": "Comment ajouter les tarifs, la disponibilité et les détails des chambres à ma réponse ?",
  "faq.rates.availability.answer": "Utilisez la fonctionnalité + Rates pour saisir les informations des clients, comme les dates et le nombre de personnes. Concierge ajoutera la disponibilité et les tarifs exacts dans votre réponse. Vous pouvez également utiliser + Rooms pour ajouter des descriptions et des images des chambres.",

  "faq.different.language.question": "Que dois-je faire si l'e-mail est dans une autre langue ?",
  "faq.different.language.answer": "Aven Hospitality Concierge vous permet de traduire les e-mails entrants dans votre langue préférée. Vous pouvez ensuite générer ou modifier une réponse et la retraduire dans la langue du client avant l'envoi.",

  "faq.pin.addin.question": "Comment m'assurer que le module complémentaire est toujours disponible dans Outlook ?",
  "faq.pin.addin.answer": "Pour garder Aven Hospitality Concierge toujours visible, épinglez le module complémentaire dans Outlook. Il s'ouvrira automatiquement avec chaque e-mail.",

  "faq.knowledge.hub.question": "Qu'est-ce que l'option de recherche Knowledge Hub ?",
  "faq.knowledge.hub.answer": "La recherche Knowledge Hub permet de trouver rapidement des informations spécifiques à l'établissement directement dans Outlook.",

  "faq.reply.email.myma.question": "Comment répondre à un e-mail avec Myma ?",
  "faq.reply.email.myma.answer": "Ouvrez l'e-mail et lancez le module complémentaire Myma. Vous pouvez utiliser un modèle, générer une réponse IA ou convertir l'e-mail en ticket.",

  "faq.room.details.question": "Comment ajouter les détails des chambres à ma réponse ?",
  "faq.room.details.answer": "Utilisez + Rooms pour inclure les descriptions et les images des chambres.",

  "faq.myma.different.language.question": "Que dois-je faire si l'e-mail est dans une autre langue ?",
  "faq.myma.different.language.answer": "Myma permet de traduire les e-mails entrants dans votre langue préférée avant de générer ou modifier une réponse.",

  "faq.myma.pin.addin.question": "Comment m'assurer que le module complémentaire est toujours disponible dans Outlook ?",
  "faq.myma.pin.addin.answer": "Épinglez le module complémentaire Myma dans Outlook afin qu'il s'ouvre automatiquement avec chaque e-mail."

};
export default chMessages;
